import React from 'react'
import { useSelector } from 'react-redux'
import { selectShowQRCode } from 'selectors/mainView'
import { MovableModalContainer } from 'components/MovableModal'
import QRCode from './QRCode'

export const QRCodeContainer = () => {
  const isShowQRCode = useSelector(selectShowQRCode)
  return (
    <MovableModalContainer
      visible={isShowQRCode}
      width={350}
      height={310}
      withBackground
      windowId="QRCode"
      pointerEvents={false}
    >
      <QRCode />
    </MovableModalContainer>
  )
}
